import { DropboxAppRow } from '../components/DropboxAppRow';
import type { AppRow } from '../type/AppRow';

export const dropboxAppRow: AppRow = {
  key: 'dropbox',
  name: 'Dropbox',
  AppComponent: DropboxAppRow,
};
